import VueWStorage from '../vue3-wstorage/index'

export default function useWStorage(app) {
    app.use(VueWStorage, {
        name: 'storage',
        key: 'inverbis:0.0.1',
    })
}
